// extracted by mini-css-extract-plugin
export default {"root":"nI8vSksNew","root_leftAligned":"bhLUhPMZ2n","content":"T23IkZQOqG"};